export default "__VITE_ASSET__Bu7PfEhU__"